¿
<template>
  <div>
    <!-- ================= DETALLE CON CARIÑO ================= -->
    <section ref="raiz" class="lluvia-sobres">
      <div class="contenido">
        <!-- TÍTULO -->
        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Regalos</span><br />
          <span class="script"></span>
        </h2>

        <!-- OPCIÓN 1: LLUVIA DE SOBRES -->
        <div ref="opcionSobresRef">
          <p class="texto">
            El regalo es opcional, ¡tu presencia obligatoria! ✨<br />
            Pero si deseas tener un detalle conmigo, te dejo las siguientes opciones.
          </p>
          <img :src="sobrePng" alt="Sobre" class="icono-sobre" />
                    <p class="subtitulo-opcion"> Lluvia de Sobres</p>

        </div>

    
        

        <!-- GRACIAS -->
        <p ref="graciasRef" class="gracias">¡GRACIAS!</p>
      </div>

      <div ref="lluviaIzq" class="lluvia lluvia-izq" aria-hidden="true"></div>
      <div ref="lluviaDer" class="lluvia lluvia-der" aria-hidden="true"></div>
    </section>

    <!-- ================= ACCESO A NIÑOS ================= -->
  
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {
    // PRIMER BLOQUE (Detalle con cariño)
    const raiz = ref(null)
    const florRef = ref(null)
    const tituloRef = ref(null)
    const opcionSobresRef = ref(null)
    const separadorRef = ref(null)
    const opcionBancoRef = ref(null)
    const graciasRef = ref(null)
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    // SEGUNDO BLOQUE (Acceso a niños)
    const raizNinos = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)
    const sobreNinosRef = ref(null)
    const graciasNinosRef = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    // timeouts y scrolltriggers
    let toDer = null
    let toIzq = null
    let toDerNinos = null
    let toIzqNinos = null
    let stInstance = null
    let stInstanceNinos = null

    const crearLluvia = (contenedorEl, lado = 'der', cantidad = 10) => {
      if (!contenedorEl) return
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.alt = ''
        el.className = 'sobre-lluvia'

        if (!contenedorEl.appendChild) return
        contenedorEl.appendChild(el)

        const rndDelay = gsap.utils.random(0, 0.5)
        const rndDur = gsap.utils.random(1.8, 2.6)
        const rndScale = gsap.utils.random(0.35, 0.7)
        const rndRot = gsap.utils.random(-25, 25)
        const xStart = lado === 'der' ? 110 : -10
        const xEnd = lado === 'der' ? -20 : 120
        const yStart = gsap.utils.random(-20, 20)
        const yEnd = gsap.utils.random(120, 140)

        gsap.fromTo(
          el,
          { xPercent: xStart, yPercent: yStart, rotate: rndRot, scale: rndScale, opacity: 0 },
          {
            xPercent: xEnd,
            yPercent: yEnd,
            rotate: rndRot + gsap.utils.random(-60, 60),
            opacity: 0.9,
            duration: rndDur,
            ease: 'power2.out',
            delay: rndDelay,
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      // PRIMER BLOQUE (Animación consecutiva / secuencial ordenada)
      stInstance = ScrollTrigger.create({
        trigger: raiz.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          const serifEl = tituloRef.value?.querySelector('.serif')
          const scriptEl = tituloRef.value?.querySelector('.script')

          // 1. Título
          if (serifEl) {
            tl.fromTo(serifEl, { opacity: 0, y: -24 }, { opacity: 1, y: 0, duration: 0.5 })
          }
          if (scriptEl) {
            tl.fromTo(scriptEl, { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: 0.45 }, '-=0.2')
          }

          // 2. Opción 1 (Lluvia de sobres completa)
          if (opcionSobresRef.value) {
            tl.fromTo(opcionSobresRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.5 }, '-=0.1')
          }

          // 3. Separador Rombo
          if (separadorRef.value) {
            tl.fromTo(separadorRef.value, { opacity: 0, scale: 0.7 }, { opacity: 1, scale: 1, duration: 0.4 }, '-=0.1')
          }

          // 4. Opción 2 (Datos de Banco)
          if (opcionBancoRef.value) {
            tl.fromTo(opcionBancoRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.5 }, '-=0.1')
          }

          // 5. Gracias
          if (graciasRef.value) {
            tl.fromTo(graciasRef.value, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.35 }, '-=0.05')
          }

          toDer = setTimeout(() => crearLluvia(lluviaDer.value, 'der', 12), 150)
          toIzq = setTimeout(() => crearLluvia(lluviaIzq.value, 'izq', 12), 300)
        }
      })

      // SEGUNDO BLOQUE
      stInstanceNinos = ScrollTrigger.create({
        trigger: raizNinos.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const tl2 = gsap.timeline({ defaults: { ease: 'power3.out' } })

          const serifEl2 = tituloNinosRef.value?.querySelector('.serif')

          if (serifEl2) {
            tl2.fromTo(serifEl2, { opacity: 0, y: -24 }, { opacity: 1, y: 0, duration: 0.5 })
          }

          if (textoNinosRef.value) {
            tl2.fromTo(textoNinosRef.value, { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.4 }, '-=0.05')
          }

          toDerNinos = setTimeout(() => crearLluvia(lluviaNinosDer.value, 'der', 12), 80)
          toIzqNinos = setTimeout(() => crearLluvia(lluviaNinosIzq.value, 'izq', 12), 220)
        }
      })
    })

    onUnmounted(() => {
      if (toDer) clearTimeout(toDer)
      if (toIzq) clearTimeout(toIzq)
      if (toDerNinos) clearTimeout(toDerNinos)
      if (toIzqNinos) clearTimeout(toIzqNinos)
      if (stInstance) stInstance.kill()
      if (stInstanceNinos) stInstanceNinos.kill()
      ScrollTrigger.refresh()
    })

    return {
      raiz,
      florRef,
      tituloRef,
      opcionSobresRef,
      separadorRef,
      opcionBancoRef,
      graciasRef,
      lluviaIzq,
      lluviaDer,
      raizNinos,
      tituloNinosRef,
      textoNinosRef,
      sobreNinosRef,
      graciasNinosRef,
      lluviaNinosIzq,
      lluviaNinosDer,
      sobrePng
    }
  }
}
</script>

<style scoped>
.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #8fbbdf;
  overflow: hidden;
}
.contenido{ position: relative; z-index: 2; }

.titulo{
  margin: 0 0 25px;
  color: #fff;
  line-height: 1.05;
}
.titulo .serif{
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}
.titulo .script{
  font-family: 'nombre', cursive;
  font-size: 44px;
  font-weight: 400;
  display: inline-block;
  opacity: .95;
}

.subtitulo-opcion {
font-family: 'padres', serif;
  font-size: 24px !important;
  color: #ffffff;  font-size: 20px;
  color: #ffffff;
  letter-spacing: 0.05em;
  margin: 15px 0 8px;
  text-transform: uppercase;
  opacity: 0.9;
}

.texto{
  font-family: 'quote', serif;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  max-width: 420px;
  margin: 8px auto 12px;
  opacity: .95;
}

.icono-sobre{
  width: 110px;
  height: auto;
  display: block;
  margin: 8px auto 20px;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.12));
}

/* ESTILOS SEPARADOR */
.separador-regalos {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  max-width: 320px;
  margin: 25px auto;
}
.separador-regalos .linea {
  flex: 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.4);
}
.separador-regalos .rombo {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

/* BLOQUE BANCO */
.bloque-banco {
  margin-bottom: 30px;
}
.tarjeta-banco {
 
  padding: 16px 20px;
  max-width: 360px;
  margin: 10px auto 0;
}
.banco-nombre {
font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff; 
  color: #ffffff;
  margin: 0 0 6px;
  letter-spacing: 1px;
}
.banco-cuenta {
font-family: 'Montserrat', sans-serif; font-size: 20px;
  color: #ffffff;
  letter-spacing: 2px;
  margin: 0 0 8px;
}
.banco-titular {
  font-family: 'quote', serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
}
.banco-titular span {
  font-weight: 600;
  color: #ffffff;
  font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff;
}

.gracias{
  font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: .08em;
  font-weight: 800;
  margin: 20px 0 0;
}

.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}
.lluvia-izq{ left: 0; }
.lluvia-der{ right: 0; }

.sobre-lluvia{
  position: absolute;
  top: -10%;
  left: 0;
  width: 28px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.10));
}

@media (max-width: 380px){
  .titulo .serif{ font-size: 50px; }
  .titulo .script{ font-size: 40px; }
  .icono-sobre{ width: 96px; }
  .banco-cuenta { font-size: 18px; }
}
</style>

```